import { DeviceDiscoveryTransactions } from '@shure/shared/angular/data-access/device-discovery';
import {
	DeviceAuthentication,
	DeviceModel,
	MissingFeatureType
} from '@shure/shared/angular/data-access/system-api/models';

export interface SpectrumScannerDevice {
	id: string;
	name: string;
	model: DeviceModel;
	roomId: string;
	authentication?: DeviceAuthentication & MissingFeatureType;
	scanStatus: {
		status: SpectrumScanStatus | undefined;
	} & MissingFeatureType;
	results: {
		current: SpectrumScannerResults;
		cumulative: SpectrumScannerResults;
	};
	rfBandNumber: string;
	rfBandRanges: {
		min: number;
		max: number;
	}[];
}

export interface SpectrumScannerResults {
	standardDensity: SpectrumScannerResultChannelCount;
	highDensity: SpectrumScannerResultChannelCount;
	rfAvailability: SpecturmScannerResultRfAvailability;
}

export interface SpectrumScannerResultChannelCount {
	strongEstimates: {
		max: number;
		min: number;
	};
	maximumEstimates: {
		max: number;
		min: number;
	};
}

export interface SpecturmScannerResultRfAvailability {
	high: number;
	moderate: number;
	no: number;
}

export interface SpectrumScannerRoomDevice {
	id: string;
	scanSupported: boolean;
}

export type SpectrumScannerDeviceTransactions = DeviceDiscoveryTransactions<SpectrumScannerDevice>;

export enum SpectrumScanStatus {
	Offline = 'Offline',
	Scanning = 'Scanning',
	NotScanning = 'NotScanning',
	NotYetAvailable = 'NotYetAvailable'
}
